import api from '@/services/apiConfig';

export const banUser = async (userId, body) => {
  const { dateFrom, dateTo, reason = '' } = body;

  try {
    const response = await api.post(`/admin/banUser/`, {
      banUserId: userId,
      dateFrom,
      dateTo,
      reason,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const unbanUser = async (userId) => {
  try {
    const response = await api.post(`/admin/unbanUser/`, {
      bannedUserId: userId,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllBans = async () => {
  try {
    const response = await api.get(`/admin/all-bans-history`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateUserAsAdmin = async (userId, body, setAlert) => {
  try {
    const response = await api.post(`/admin/updateUser/${userId}`, body);

    setAlert({ type: 'Success', message: 'User successfuly updated!' });

    return response.data;
  } catch (error) {
    const errorMsg = error.response.data?.error ?? error;

    setAlert({ type: 'Error', message: errorMsg });

    return;
  }
};

export const getAdminDashboardStats = async () => {
  try {
    const response = await api.get('/admin/dashboard-stats');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const liftExpiredBans = async () => {
  try {
    const response = await api.post('/admin/lift-expired-bans');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getRecentActivities = async () => {
  try {
    const response = await api.get('/admin/recent-activities');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getServerStatus = async () => {
  try {
    const response = await api.get('/admin/server-status');
    return response.data;
  } catch (error) {
    throw error;
  }
};
